// extracted by mini-css-extract-plugin
export default {"container":"styles__container___yQpzX","checkWrapper":"styles__checkWrapper___InE1A","checkIcon":"styles__checkIcon___7967u","titleReady":"styles__titleReady___KHcTP"};